module.exports = __webpack_public_path__ + "img/门铰链2.5f6fa240.jpg";